<template>
  <div class="container">
    <content-template>
      <template slot="left">{{activity.name}}</template>
      <template slot="right">
        <li>
          <router-link  :to="{path:'activity-rules',query: {id:activity.id}}" >簡介及比賽規章</router-link>
        </li>
        <li>
          <a class="is-check" style="color: #5571EC;">線上報名</a>
        </li>
        <li>
          <router-link :to="{path:'activity-works',query:{id:activity.id}}">比賽作品</router-link>
        </li>
      </template>
      <template slot="banner">
        <div class="col-xs-12 activity-bg none-padding" style="text-align: center;">
          <img :src="activity.banner_url" style="padding:0px; max-width: 100%;" alt="">
        </div>
      </template>
      <template slot="content">
        <!--報名表-->
        <div class="col-xs-12 col-sm-8 col-sm-offset-2  hy-form " v-if="!isSuccess">
          <template v-if="activity.register_start_time < nowTime && activity.register_end_time > nowTime">
            <form id="the-form"  enctype="multipart/form-data" @submit.prevent="addPost">
              <div class="one-member clearfix">

                <div class="col-xs-12 form-one-field" v-for="(field,index) in fields" :key="index">
                  <div v-if="field[1]">
                    <div v-html="field[0]" class="col-xs-4 form-field-left"></div>
                    <!--********************文件上传********************-->
                    <div v-if="field[0] == '上傳作品：'">
                      <div class="col-xs-8 form-field-right">
                        <!--如果是视频或者照片-->
                        <div v-if="field[1].name">
                          <input type="hidden" :name="field[1].name" :value="fileValue.file_url">
                          <input required type="file" :accept="field[1].accept" class='form-file' @change="fileUpload"  :size="field[1].size" >
                        </div>
                        <!--文字-->
                        <div v-else>
                          <div v-html="field[1]"></div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-html="field[1]"  class="col-xs-8 form-field-right"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-html="field[0]" class="col-xs-12 form-field-left"></div>
                  </div>
                </div>

              </div>

              <div class="identifying-code clearfix">
                <div class="col-xs-12 " style="text-align: center">
                    <div class="col-xs-12 col-sm-6" style="text-align:right;">
                      <span>验证</span>
                      <input type="text" required v-model="inputCode">
                      <img :src="code" @click="changeCode" alt="验证码" style="cursor: pointer">
                    </div>
                    <div class="col-xs-12 col-sm-5 online-btn">
                      <!--<button type="submit" @click="addPost">提交</button>-->
                      <button type="submit" :disabled="isDisable" >提交</button>
                      <button type="button" class="ac-btn-back" @click="ThisRefresh">返回</button>
                    </div>
                    <!--<button type="button" class="col-xs-12 col-sm-5" @click="addPost">提交</button>-->

                    <div v-if="tips" class="col-xs-12" style="text-align: center; margin-top: 15px; color: red;">
                      {{tips}}
                    </div>
                </div>
              </div>
              <input type="hidden" name="activity_id" :value="activity.id">
            </form>
          </template>
          <templaet v-else-if="activity.register_start_time > nowTime">
            <div class="enroll-success" style="text-align: center">報名還未開始</div>

          </templaet>
          <template v-else-if="activity.register_end_time < nowTime">
            <div class="enroll-success" style="text-align: center">報名已結束</div>
          </template>
        </div>
        <!--報名成功-->
        <div class="col-xs-12 col-sm-8 col-sm-offset-2  hy-form " v-if="isSuccess">
          <div class="enroll-success">
            報名成功！將在兩日內將作品公佈 <br>
            <button @click="ThisRefresh">完成</button>
          </div>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
import Vue from 'vue'
export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      nowTime: 0,          // 当前时间
      activity: [],     // 活动内容
      fields: [],       // 表单字段
      inputCode: '',   // 验证码
      tips: '',
      isSuccess: false,
      formValue: {},    // 报名表数据
      fileValue: {},    // 文件数据
      code: this.$url + 'home/code',
      codeNum: '',
      isDisable: false,
      photoResource: {
        url: 'aaa',
        filename: 'bbb'
      }  // 照片上传后返回的资源
    }
  },
  mounted: function () {
    var nowTime = Date.parse(new Date()).toString()
    this.nowTime = nowTime.substr(0, 10)
    // this.fourthStu = {}
    // console.log(this.fourthStu)
    this.getActivity(this.getField)

  },
  computed: {
    // this.teamMember4.id_card_urls = this.fourthCard.url
  },
  methods: {

    changeCode: function () {
      this.code = this.$url + 'home/code?d=' + Math.random()
    },
    addPost: function () {
      const that = this
      var fValue = $('#the-form').serializeArray()

      var inputData = {
        code: this.inputCode,
        form: fValue
      }
      this.$axios({
        url: 'activity/add',
        method: 'post',
        data: this.$qs.stringify(inputData)
      })
        .then(function (response) {
          that.isDisable = true
          if (response.data.code === 1) {
            // console.log(response.data)
            that.isSuccess = true
            setTimeout (function () {
              that.$router.push({name: 'activity-rules', query: {id: that.$route.query.id}})
            }, 5000)
            that.isDisable = false
          } else {
            if (response.data.msg === '验证码错误') {
              that.changeCode()
            }
            that.tips = response.data.msg
            that.isDisable = false
          }
        })
        .catch(function (error) {
          // console.log(error)
        })
    },
    update: function (e, self, data) {
      var that = this
      let file = e.target.files[0]
      let param = new FormData()  // 创建form对象
      param.append('file', file)
      // console.log(param.get('file'))
      // let config = {
      //   headers: {'Content-Type': 'multipart/form-data'}
      // }
      var url = '/user/upload/one'
      self.$axios.post(url, param)
        .then(function (response) {
          // 成功返回图片名称和图片存储路径
          if (response.data.code === 1) {
            Vue.set(data, 'file_url', response.data.data.url)
            // console.log('aaa', self.fileValue)
          }
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fileUpload: function (e) {
      var self = this
      this.update(e, self, this.fileValue)
    },
    // 根据活动id获取活动
    getActivity: function (callback) {
      var id = this.$route.query.id
      var that = this
      this.$axios.get('/activity/' + id)
        .then(function (response) {
          that.activity = response.data.data
          // that.registerTime = that.activity.register_start_time + '至' + that.activity.register_end_time
          // that.formValue.activity_id = that.activity.id
          callback(that.activity.form_id)
          // console.log(that.activity)
          // that.getField(1)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 根据表单id获取报名表单内容
    getField: function (formId) {
      var that = this
      this.$axios.get('/activity/form/' + formId)
        .then(function (response) {
          that.fields = response.data.data
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ThisRefresh: function () {
      var that = this
      this.$router.push({name: 'activity-rules', query: {id: that.$route.query.id}})
    }
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  /*頂部提示結束*/

  /*參賽隊伍資料*/
  .hy-form{
    margin-top: 20px;
    padding: 0px;
  }
  .hy-form h4 {
    color: #617BE4;
    font-size: 16px;

  }

  .hy-form table {
    /*border-collapse: collapse;*/
    padding: 0px;
  }

  .hy-form tr {
    /*margin-top: 20px;*/
    padding-top: 20px;
    height: 60px;
  }

  .hy-form th, .hy-form td {
    padding: 0.3em;
  }

  .hy-form th {
    font-size: 14px;
  }

  .team input {
    /*width: 100%;*/
    background: #F2F7FC;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .team select {
    background: #F2F7FC;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .one-member {
    background: #F4F4F4;
    border-radius: 8px;
    padding: 0px;
  }
  .one-member .form-one-field{
    margin: 15px 0px;
  }
  .form-field-left{
    display: inline-block;
    text-align: center;
    padding: 0px;
  }
  .form-field-right{
    display: inline-block;
    padding: 0px;
  }

  .identifying-code {
    background: #F2F7FC;
    border-radius: 8px;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 16px;
  }

  .identifying-code input {
    width: 100px;
    border: 1px solid #DCDEE1;
    border-radius: 8px;
  }

  .identifying-code button {
    background: #5571EC;
    border-radius: 100px;
    width: 100px;
    height: 40px;
    color: #fff;
  }
  .identifying-code .ac-btn-back{
    background: #FFFFFF;
    color: rgba(85,113,236,1);
    border:2px solid rgba(85,113,236,1);
  }

  @media (min-width: 992px) {

  }

  @media (max-width: 992px) {

  }

  @media (max-width: 768px) {
    .hy-form {
      font-size: 14px;
    }
    .one-member .form-one-field{
      margin: 10px 0px;
    }

    .online-btn{
      margin-top: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/activity/onlineEnroll.vue